<template>
  <pp-modal v-model="showModal" :mask-closable="false" width="488">
    <p slot="header" class="modalHead">
      <span>{{$t('webList.webDetail.paymentToday')}}</span>
    </p>
    <div class="modalContent">
      <p>{{$t('webList.webDetail.paymentTip')}}: <a style="color:#00A3EE">{{currency}} {{$filters.money(todayWithdrawnumber)}}</a></p>
    </div>
    <div slot="footer" class="textright">
      <!--<pp-button class="pp-btn pp-btn-ghost pp-btn-spec" @click="leftBtnFun">取消</pp-button>-->
      <!--<pp-button class="pp-btn pp-btn-primary pp-btn-spec" @click="leftBtnFun">确定</pp-button>-->
    </div>
  </pp-modal>
</template>

<script>
  import {
    Component,
    Vue,
    Prop,
    Watch
  } from 'vue-property-decorator'

  export default {
    name: 'successModal',
    props: {
      todayWithdrawnumber: '',
      currency: ''
    },
    mounted() {
    },
    data() {
      return {
        showModal: false
      }
    },
    methods: {
      leftBtnFun() {
        this.showModal = false
      },
      show() {
        this.showModal = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modalHead {
    color: #000;
    font-size: 20px;
    text-align: left
  }

  .modalContent {
    text-align: left;
    font-size: 14px;
  }
</style>
